import type { MessagingGetChatRoomById200BasicInfo } from './messagingGetChatRoomById200BasicInfo';
import type { MessagingGetChatRoomById200LastMessage } from './messagingGetChatRoomById200LastMessage';
import type { MessagingGetChatRoomById200ParticipantsItem } from './messagingGetChatRoomById200ParticipantsItem';
import type { MessagingGetChatRoomById200TimeInfo } from './messagingGetChatRoomById200TimeInfo';

export type MessagingGetChatRoomById200 = {
  basicInfo?: MessagingGetChatRoomById200BasicInfo;
  /** 마지막 메시지 */
  lastMessage?: MessagingGetChatRoomById200LastMessage;
  /** 참여자 목록 */
  participants?: MessagingGetChatRoomById200ParticipantsItem[];
  /** 시간 관련 정보 */
  timeInfo?: MessagingGetChatRoomById200TimeInfo;
};
